<template>
    <div class="left_panel order_detail_left_panel">
        <h2 class="font_size_20">Order Details</h2>
        <div class="contact_detail_wrap top_wrap position-relative order_details_shipping order_details_card_boady_custom" v-if="order">
            <div class="order_details_top_meta_strip" v-if="order">
                <div class="">
                    <h3 class="order_no">#{{ order.unique_order_id }}</h3>
                    <div class="sub_text">Ordered On: {{ order.created_at | formatDate }}</div>
                    <div class="my-1">
                        <span
                            class="status_btn btn_back_order"
                            :class="{ 'status-is-new': order.status === 'NEW' }"
                        >{{ displayOrderStatusLabel(order.status) }}</span>
                    </div>
                </div>

                <!-- <div class="d-flex">
                    <div class="order_details_meta_grid">
                        <div class="order_details_meta_item">
                            <div class="order_details_meta_label">Vendor :</div>
                            <div class="order_details_meta_value">{{ getOrderTopVendorNames() }}</div>
                        </div>
                        <div class="order_details_meta_item">
                            <div class="order_details_meta_label">Decorator :</div>
                            <div class="order_details_meta_value">{{ getOrderTopDecoratorNames() }}</div>
                        </div>
                        <div class="order_details_meta_item">
                            <div class="order_details_meta_label">Netsuite External ID :</div>
                            <div class="order_details_meta_value">{{ order.netsuite_external_id ? order.netsuite_external_id : '—' }}</div>
                        </div>
                        <div class="order_details_meta_item">
                            <div class="order_details_meta_label">Netsuite SO Number :</div>
                            <div class="order_details_meta_value">{{ order.netsuite_so_number ? order.netsuite_so_number : '—' }}</div>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="row order_details_header_row" v-if="order && order.NewOrderAddresses.length > 0">
                <div class="col-md-12">
                    <div class="row">
                        <!-- BILL TO -->
                        <div class="col-md-4">
                            <div class="heading_label">BILL TO</div>
                            <div class="sub_text name_sub_text_custom">
                                <div class="order_kv_row" v-if="billing_address.address_label">
                                    <span class="order_kv_label">
                                        <span class="order_kv_label_text">Company Name</span>
                                        <span class="order_kv_colon">:</span>
                                    </span>
                                    <span class="order_kv_value">{{ billing_address.address_label }}</span>
                                </div>
                                <div class="order_kv_row" v-if="billing_address.first_name && billing_address.last_name">
                                    <span class="order_kv_label">
                                        <span class="order_kv_label_text">Recipient Name</span>
                                        <span class="order_kv_colon">:</span>
                                    </span>
                                    <span class="order_kv_value">{{ billing_address.first_name + ' ' + billing_address.last_name }}</span>
                                </div>
                                <div class="order_kv_row" v-else>
                                    <span class="order_kv_label">
                                        <span class="order_kv_label_text">Recipient Name</span>
                                        <span class="order_kv_colon">:</span>
                                    </span>
                                    <span class="order_kv_value">{{ order.NewOrderAddresses[0].fullname }}</span>
                                </div>

                                <div
                                    class="order_kv_row order_kv_address"
                                    v-if="billing_address.address1 || billing_address.address2 || billing_address.city || billing_address.state || billing_address.zip"
                                >
                                    <span class="order_kv_label">
                                        <span class="order_kv_label_text">Address</span>
                                        <span class="order_kv_colon">:</span>
                                    </span>
                                    <div class="order_kv_value">
                                        <div v-if="billing_address.address1">{{ billing_address.address1 }}</div>
                                        <div v-if="billing_address.address2">{{ billing_address.address2 }}</div>
                                        <div v-else>
                                            {{
                                                [billing_address.city, billing_address.state]
                                                    .filter(Boolean)
                                                    .join(', ') + (billing_address.zip ? ' ' + billing_address.zip : '')
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <div v-if="billing_address.phone" class="order_kv_row">
                                    <span class="order_kv_label">
                                        <span class="order_kv_label_text">Phone No</span>
                                        <span class="order_kv_colon">:</span>
                                    </span>
                                    <a :href="'tel:' + billing_address.phone" class="phone_mail_a_tag_custom">
                                        <img src="/maincss/images/icons/call.svg" alt="icon">
                                        <span>{{ billing_address.phone }}</span>
                                    </a>
                                </div>
                                <div class="phone phone-email">
                                    <span class="order_kv_label">
                                        <span class="order_kv_label_text">Email</span>
                                        <span class="order_kv_colon">:</span>
                                    </span>
                                    <a :href="'mailto:' + billing_address.email" class="phone_mail_a_tag_custom">
                                        <img src="/maincss/images/icons/envelope.svg" alt="icon">
                                        <span>{{ billing_address.email }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <!-- SHIP TO (hidden when shipping row exists but no persisted address id) -->
                        <div
                            v-if="showShipToSection"
                            class="col-md-4 order_details_shipping group_shipment_popup"
                        >
                            <div class="heading_label">SHIP TO</div>
                            <div class="sub_text name_sub_text_custom">
                                <div class="order_kv_row" v-if="order.is_split_shipment">
                                    <span class="order_kv_label">
                                        <span class="order_kv_label_text" style="font-weight: bold;">Multiple Shipment</span>
                                        <span class="order_kv_colon">:</span>
                                    </span>
                                    <span class="order_kv_value">{{ addressesWithSplits.length || 1 }} Locations</span>
                                </div>

                                <div class="order_kv_row" v-if="shipping_address.shippingaddress_title">
                                    <span class="order_kv_label">
                                        <span class="order_kv_label_text">Address Title</span>
                                        <span class="order_kv_colon">:</span>
                                    </span>
                                    <span class="order_kv_value">{{ shipping_address.shippingaddress_title }}</span>
                                </div>

                                <div class="order_kv_row" v-if="shipping_address.shippingaddress_label">
                                    <span class="order_kv_label">
                                        <span class="order_kv_label_text">Company Name</span>
                                        <span class="order_kv_colon">:</span>
                                    </span>
                                    <span class="order_kv_value">{{ shipping_address.shippingaddress_label }}</span>
                                </div>

                                <div class="order_kv_row" v-if="shipping_address.first_name && shipping_address.last_name">
                                    <span class="order_kv_label">
                                        <span class="order_kv_label_text">Recipient Name</span>
                                        <span class="order_kv_colon">:</span>
                                    </span>
                                    <span class="order_kv_value">{{ shipping_address.first_name + ' ' + shipping_address.last_name }}</span>
                                </div>
                                <div class="order_kv_row" v-else>
                                    <span class="order_kv_label">
                                        <span class="order_kv_label_text">Recipient Name</span>
                                        <span class="order_kv_colon">:</span>
                                    </span>
                                    <span class="order_kv_value">{{ order.NewOrderAddresses[0].fullname }}</span>
                                </div>

                                <div
                                    class="order_kv_row order_kv_address"
                                    v-if="shipping_address.address1 || shipping_address.address2 || shipping_address.city || shipping_address.state || shipping_address.zip"
                                >
                                    <span class="order_kv_label">
                                        <span class="order_kv_label_text">Address</span>
                                        <span class="order_kv_colon">:</span>
                                    </span>
                                    <div class="order_kv_value">
                                        <div v-if="shipping_address.address1">{{ shipping_address.address1 }}</div>
                                        <div v-if="shipping_address.address2">{{ shipping_address.address2 }}</div>
                                        <div v-else>
                                            {{
                                                [shipping_address.city, shipping_address.state]
                                                    .filter(Boolean)
                                                    .join(', ') + (shipping_address.zip ? ' ' + shipping_address.zip : '')
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <div class="order_kv_row">
                                    <span class="order_kv_label">
                                        <span class="order_kv_label_text">Phone No</span>
                                        <span class="order_kv_colon">:</span>
                                    </span>
                                    <a :href="'tel:' + shipping_address.phone" class="phone_mail_a_tag_custom">
                                        <img src="/maincss/images/icons/call.svg" alt="icon">
                                        <span>{{ shipping_address.phone }}</span>
                                    </a>
                                </div>
                                <div class="phone phone-email">
                                    <span class="order_kv_label">
                                        <span class="order_kv_label_text">Email</span>
                                        <span class="order_kv_colon">:</span>
                                    </span>
                                    <a :href="'mailto:' + shipping_address.email" class="phone_mail_a_tag_custom">
                                        <img src="/maincss/images/icons/envelope.svg" alt="icon">
                                        <span>{{ shipping_address.email }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <!-- SHIPPING METHOD + PAYMENT METHOD -->
                        <div class="col-md-4 order_details_shipping group_shipment_popup">
                            <div class="heading_label">Ship Method</div>
                            <div class="sub_text name_sub_text_custom shipping-method-wrap">
                                <label class="shipping-method-carrier">
                                    <img
                                        v-if="isFedExMethod(getAddressShippingMethod(order && order.NewOrderAddresses, order && order.ship_method), order && order.ShippingCarrier ? order.ShippingCarrier.shpping_provider : '') && allowShipMethodCarrierBranding(order && order.shipping_option)"
                                        src="/maincss/images/fedex1.png"
                                        alt="FedEx"
                                        class="shipping-method-logo"
                                    />
                                    <span
                                        v-else-if="!isFedExMethod(getAddressShippingMethod(order && order.NewOrderAddresses, order && order.ship_method), order && order.ShippingCarrier ? order.ShippingCarrier.shpping_provider : '') && allowShipMethodCarrierBranding(order && order.shipping_option)"
                                    >{{ formatCarrierName(order && order.ShippingCarrier ? order.ShippingCarrier.shpping_provider : "") }}</span>
                                    <span class="shipping-method-name">{{ getAddressShippingMethod(order && order.NewOrderAddresses, order && order.ship_method) }}</span>
                                </label>
                            </div>

                            <div class="order_num" v-if="showPaymentMethodSection">
                                <div class="bill_details font_size_14 mt_10">
                                    <div class="heading_label">Payment Method</div>
                                </div>

                                <!-- card with remaining_pay_card_details -->
                                <template v-if="card_payment_details && card_payment_details.payment_details && card_payment_details.payment_details.remaining_pay_card_details">
                                    <div class="payment-method-card-row">
                                        <img
                                            :src="getCardImage(card_payment_details.payment_details.remaining_pay_card_details.cardtype)"
                                            :alt="card_payment_details.payment_details.remaining_pay_card_details.cardtype"
                                            class="payment-card-logo"
                                        />
                                        <span class="payment-card-number">XXXX XXXX XXXX {{ card_payment_details.payment_details.remaining_pay_card_details.cardnumber }}</span>
                                    </div>
                                    <div class="payment-amount-row">
                                        <span class="payment-amount-label">Amount:</span>
                                        <span class="payment-amount-value">{{ icPriceFormat(card_payment_details.amount) }}</span>
                                    </div>
                                </template>

                                <!-- card with direct payment_details -->
                                <template v-else-if="card_payment_details && card_payment_details.payment_details">
                                    <div class="payment-method-card-row">
                                        <img
                                            :src="getCardImage(card_payment_details.payment_details.cardtype)"
                                            :alt="card_payment_details.payment_details.cardtype"
                                            class="payment-card-logo"
                                        />
                                        <span class="payment-card-number">XXXX XXXX XXXX {{ card_payment_details.payment_details.cardnumber }}</span>
                                    </div>
                                    <div class="payment-amount-row">
                                        <span class="payment-amount-label">Amount:</span>
                                        <span class="payment-amount-value">{{ icPriceFormat(card_payment_details.amount) }}</span>
                                    </div>
                                </template>

                                <div class="sub_text mt-2" v-if="term_payment_details && term_payment_details.payment_details && (parseFloat(term_payment_details.payment_details.credit_reduce) > 0)">
                                    <p>Payment Type: Term Payment</p>
                                    <p>Credit Applied: {{ icPriceFormat(term_payment_details.payment_details.credit_reduce) }}</p>
                                    <p>Available Credit: {{ icPriceFormat(term_payment_details.payment_details.remaining_balance) }}</p>
                                </div>

                                <div v-if="showPayNow" class="mt-3">
                                    <button
                                        type="button"
                                        class="btn btn_orange bg_primary_orange text_white"
                                        @click="goToPendingPayment"
                                    >
                                        Pay Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="order_details_note_bar" v-if="order.remarks">
                Notes: {{ order.remarks || "Leave the package at the doorstep" }}
            </div>
        </div>
        <div class="contact_detail_wrap top_wrap position-relative order_details_shipping" v-if="order && (additional_card_payment || additional_term_payment)">
            <div class="row">

                <div class="col-lg-3 col-md-3 custom-break-3 pl_30">
                    <div class="order_num mt_10">
                        <h3>Additional Payment</h3>
                        <div class="bill_details font_size_14">
                            <p class="ship_to">Payment Method</p>
                        </div>
                        <div v-if="additional_card_payment && additional_card_payment.payment_details && additional_card_payment.payment_details.remaining_pay_card_details">
                            <div class="payment-method-card-row">
                                <img :src="getCardImage(additional_card_payment.payment_details.remaining_pay_card_details.cardtype)" :alt="additional_card_payment.payment_details.remaining_pay_card_details.cardtype" class="payment-card-logo" />
                                <span class="payment-card-number">XXXX XXXX XXXX {{ additional_card_payment.payment_details.remaining_pay_card_details.cardnumber }}</span>
                            </div>
                            <div class="payment-amount-row">
                                <span class="payment-amount-label">Amount:</span>
                                <span class="payment-amount-value">{{ icPriceFormat(additional_card_payment.amount) }}</span>
                            </div>
                        </div>
                        <div v-else-if="additional_card_payment && additional_card_payment.payment_details">
                            <div class="payment-method-card-row">
                                <img :src="getCardImage(additional_card_payment.payment_details.cardtype)" :alt="additional_card_payment.payment_details.cardtype" class="payment-card-logo" />
                                <span class="payment-card-number">XXXX XXXX XXXX {{ additional_card_payment.payment_details.cardnumber }}</span>
                            </div>
                            <div class="payment-amount-row">
                                <span class="payment-amount-label">Amount:</span>
                                <span class="payment-amount-value">{{ icPriceFormat(additional_card_payment.amount) }}</span>
                            </div>
                        </div>
                        <div class="sub_text name_sub_text_custom mt-2" v-if="additional_term_payment && additional_term_payment.payment_details">
                            <p>Payment Type: Term Payment</p>
                            <p>Credit Applied: {{ icPriceFormat(additional_term_payment.payment_details.credit_reduce) }}</p>
                            <p>Available Credit: {{ icPriceFormat(additional_term_payment.payment_details.remaining_balance) }}</p>
                        </div>
                    </div>  
                    <div class="order_num mt_10" v-if="additional_payment">
                        <div class="bill_details font_size_14">
                            <p class="ship_to">Additional Fees</p>
                        </div>
                        <div class="sub_text name_sub_text_custom ">
                            <p v-if="additional_payment.color_fees">Color Fees: {{ icPriceFormat(additional_payment.color_fees) }}</p>
                            <p v-if="additional_payment.item_fees">Item Fees: {{ icPriceFormat(additional_payment.item_fees) }}</p>
                            <p v-if="additional_payment.order_fees">Order Fees: {{ icPriceFormat(additional_payment.order_fees) }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- FINANCE STATUS -->
        <div class="card steps_card" v-if="order">
            <section class="order-details-steps pb-0 ">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-10">
                            <div class="wizard d-flex justify-content-center align-items-center">
                                <div
                                    class="field d-flex justify-content-center align-items-center"
                                    :class="{ done: order.finance_check == 'Approved' }"
                                >
                                    <div class="circle" :class="{ done: order.finance_check == 'Approved' }">
                                        <span> 1</span>
                                        <img src="/maincss/images/icons/checked.svg" alt class="checked-block" />
                                    </div>
                                    <h5 class="mb-0">Finance</h5>
                                </div>

                                <div
                                    class="field d-flex justify-content-center align-items-center"
                                    :class="{ done: order.art_dept == 'Approved' }"
                                >
                                    <div class="circle" :class="{ done: order.art_dept == 'Approved' }">
                                        <span> 2</span>
                                        <img src="/maincss/images/icons/checked.svg" alt class="checked-block" />
                                    </div>
                                    <h5 class="mb-0">Art/Design</h5>
                                </div>

                                <div
                                    class="field d-flex justify-content-center align-items-center"
                                    :class="{ done: order.production == 'Approved' }"
                                >
                                    <div class="circle dot" :class="{ done: order.production == 'Approved' }">
                                        <span> 3</span>
                                        <img src="/maincss/images/icons/checked.svg" alt class="checked-block" />
                                    </div>
                                    <h5 class="mb-0">Production</h5>
                                </div>

                                <div
                                    class="field d-flex justify-content-center align-items-center"
                                    :class="{ done: order.shipped == 'Approved' }"
                                >
                                    <div class="circle dot" :class="{ done: order.shipped == 'Approved' }">
                                        <span> 4</span>
                                        <img src="/maincss/images/icons/checked.svg" alt class="checked-block" />
                                    </div>
                                    <h5 class="mb-0">Shipped</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <!-- Tabs to switch between item-centric and address-centric views (admin-style) -->
        <div v-if="order && processedOrderData" class="order-tabs-wrapper">
            <div class="tabs-block">
                <div class="order-tabs-headings-row">
                    <div class="order-tabs-heading-left">
                        Base Product &amp; Artwork
                    </div>
                    <div class="order-tabs-heading-right">
                        Order Summary
                    </div>
                </div>
                <ul>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ active: activeTab === 'items' }"
                            href="javascript:void(0)"
                            @click="activeTab = 'items'"
                        >
                            Order Items
                        </a>
                    </li>
                    <li v-if="showViewOrderByAddressTab" class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ active: activeTab === 'byAddress' }"
                            href="javascript:void(0)"
                            @click="activeTab = 'byAddress'"
                        >
                            View Order by Address
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Order Items tab -->
        <OrderDetails
            v-if="order && processedOrderData && activeTab === 'items'"
            :order_data="processedOrderData"
            :total_non_standard_colors="total_non_standard_colors"
        />

        <!-- Items by Address tab (split shipment) -->
        <OrderItemsByAddress
            v-if="order && processedOrderData && showViewOrderByAddressTab && activeTab === 'byAddress'"
            :addresses="addressesWithSplits"
            :items-by-address="itemsByAddress"
            :order-detail="processedOrderData"
            :cost-summary="costSummaryByAddress"
            :format-price="icPriceFormat"
        />
        
        <!-- Legacy fallback removed (component-based view only) -->
        <div class="contact_detail_wrap px_30 pt_40 pb_36 notes_section" v-if="false">
            <div class="text_box_area">
                <form @submit.prevent="addComment()" data-vv-scope="addcommentform">
                    <div class="textbox_heading d-flex">
                        <h4>Notes</h4>
                        <div class="select_option sec_opt">
                            <label>To</label>
                            <v-select label="first_name" :reduce="(users) => users.id" v-model.trim="comment.user_to"
                                :options="users" :placeholder="'User'" name="user" v-validate="'required'" ref="user">
                                <template slot="option" slot-scope="option">
                                    {{ option.first_name }} {{ option.last_name }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ option.first_name }} {{ option.last_name }}
                                </template>
                            </v-select>
                            <small class="form-text text-error text-left"
                                v-show="errors.has('addcommentform.user') && isSubmit">
                                {{ errors.first("addcommentform.user") }}
                            </small>
                        </div>
                    </div>
                    <div class="text_editor">
                        <ckeditor v-model="comment.message" name="description" id="ckeditor" v-validate="'required|max:250'"
                            data-vv-as="Description" ref="editor"></ckeditor>
                        <small class="form-text text-error text-left"
                            v-show="errors.has('addcommentform.description') && isSubmit">
                            {{ errors.first("addcommentform.description") }}
                        </small>
                        <button type="submit" class="
                float-right
                mt-2
                btn btn_outline_primary
                border_primary_blue
                text_primary_blue
              ">
                            Post
                        </button>
                    </div>
                </form>
                <div class="comment_wrap">
                    <div class="comment_section">
                        <h4>Recent Comments ({{ comment_list.length }})</h4>
                        <div class="comment_box_wrap team_img_name d-flex order_comments"
                            v-for="comment in comment_list" :key="comment.id">
                            <div class="comm_img team_img">
                                <span class="font_size_14 font-weight-bold">{{ comment.sender.first_name[0] | capitalize
                                }}{{ comment.sender.last_name[0] | capitalize }}</span>
                            </div>
                            <div class="comment_area font_14">
                                <div class="name_time">
                                    <span class="name">{{
                                            comment.sender.first_name + " " + comment.sender.last_name
                                    }}</span><span class="time grey_color font_size_14">
                                        {{ comment.created_at | formatDateNow }}</span>
                                </div>
                                <div class="comments font_size_14" v-html="comment.message"></div>
                                <div class="reply grey_color font_size_14 rply_form">
                                    <a @click="focusOnEditor()">Reply</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="preloader" v-show="isBusy">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon class="rect" points="0 0 0 40 40 40 40 0"></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "@/common/api.service";
import DisplayProductImage from "@/components/DisplayProductImageNew";
import OrderDetails from "@/components/payments/OrderDetails";
import { mapGetters } from "vuex";
import { rollupFeeMixin } from "@/common/rollupFee.service";
import OrderItemsByAddress from "./components/OrderItemsByAddress.vue";

export default {
    name: "Order_detail",
    mixins: [rollupFeeMixin],
    components: { DisplayProductImage, OrderDetails, OrderItemsByAddress },
    data() {
        return {
            comment: {
                message: null,
                user_to: null,
                order_id: this.$route.params.id
            },
            isSubmit: false,
            order_id: this.$route.params.id,
            isBusy: false,
            order: null,
            item_data: [],
            product_color: [],
            users: [],
            comment_list: [],
            decoration_type_list: {
                1: "Print",
                2: "Embroidery",
                3: "Promotional"
            },
            order_fees: [],
            billing_address: {
                first_name: "",
                last_name: "",
                address1: "",
                address2: "",
                city: "",
                state: "",
                country: "",
                zip: "",
                phone: "",
                email: "",
                address_label: ""
            },
            shipping_address: {
                first_name: "",
                last_name: "",
                address1: "",
                address2: "",
                city: "",
                state: "",
                country: "",
                zip: "",
                phone: "",
                email: "",
                address_label: ""
            },
            decoration_methods: null,
            payment_detail_myJSON: null,
            additional_payment: null,
            additional_term_payment: null,
            additional_card_payment: null,
            term_payment_details: null,
            card_payment_details: null,
            total_non_standard_colors: [],
            colors_limit: 6,
            activeTab: "items",
            processedOrderData: null
        };
    },
    computed: {
        ...mapGetters(["currentUserClient", "isAuthenticatedClient"]),
        hasSplitShipments() {
            const s =
                this.order &&
                this.order.NewOrderSplitItems &&
                Array.isArray(this.order.NewOrderSplitItems)
                    ? this.order.NewOrderSplitItems
                    : [];
            return s.length > 0;
        },
        orderAddressesAll() {
            return this.order && this.order.NewOrderAddresses
                ? this.order.NewOrderAddresses
                : [];
        },
        /** Hide SHIP TO when shipping row has no linked saved address (address_id null — row id is always the order-address PK). */
        showShipToSection() {
            const addrs = this.orderAddressesAll;
            if (!addrs.length) return true;
            const ship = addrs.find((a) => a.is_shipping);
            if (!ship) return true;
            if (ship.address_id == null || ship.address_id === "") return false;
            return true;
        },
        /** "View order by address" tab — hidden for pickup warehouse (2) / delivery (3). */
        showViewOrderByAddressTab() {
            const so =
                (this.order && this.order.shipping_option) != null &&
                (this.order && this.order.shipping_option) !== ""
                    ? this.order.shipping_option
                    : this.processedOrderData && this.processedOrderData.shipping_option;
            return this.allowShipMethodCarrierBranding(so);
        },
        orderSplitItems() {
            return this.order && this.order.NewOrderSplitItems
                ? this.order.NewOrderSplitItems
                : [];
        },
        defaultOrderAddress() {
            const list = this.orderAddressesAll || [];
            return (
                list.find((a) => Number(a && a.is_default) === 1) ||
                list.find((a) => Number(a && a.split_address_sequence) === 1) ||
                list.find((a) => Number(a && a.is_shipping) === 1) ||
                list[0] ||
                null
            );
        },
        addressesWithSplits() {
            const all = this.orderAddressesAll || [];
            const map = this.itemsByAddress || {};
            const idsWithSplits = new Set(
                Object.keys(map).map((id) => parseInt(id, 10))
            );
            const splitAddresses = all.filter(
                (addr) => addr && idsWithSplits.has(parseInt(addr.id, 10))
            );
            if (splitAddresses.length > 0) {
                return splitAddresses;
            }
            return this.defaultOrderAddress ? [this.defaultOrderAddress] : [];
        },
        itemsByAddress() {
            const map = {};
            (this.orderSplitItems || []).forEach((split) => {
                const addrId = split && split.split_address_id;
                if (!addrId) return;
                if (!map[addrId]) map[addrId] = [];

                let baseItem = null;
                let sizeRow = null;
                const targetId =
                    split && split.order_item_id != null
                        ? String(split.order_item_id)
                        : null;

                const grouped = (this.processedOrderData && this.processedOrderData.items) || [];
                (grouped || []).some((g) => {
                    if (!g || !Array.isArray(g.sizes)) return false;
                    const found = g.sizes.find(
                        (s) =>
                            s &&
                            s.id != null &&
                            targetId != null &&
                            String(s.id) === targetId
                    );
                    if (found) {
                        baseItem = g;
                        sizeRow = found;
                        return true;
                    }
                    return false;
                });

                if (!baseItem) return;

                map[addrId].push({
                    split,
                    item: baseItem,
                    sizeLabel:
                        (sizeRow &&
                            sizeRow.MainNewSubProduct &&
                            sizeRow.MainNewSubProduct.Size &&
                            sizeRow.MainNewSubProduct.Size.size) ||
                        "",
                    name: "",
                    number: ""
                });
            });

            // Standard (non-split) orders: show all items under default shipping address.
            if (Object.keys(map).length === 0) {
                const fallbackAddress = this.defaultOrderAddress;
                const fallbackAddressId = fallbackAddress && fallbackAddress.id;
                if (fallbackAddressId != null) {
                    const addrKey = String(fallbackAddressId);
                    map[addrKey] = [];
                    const grouped = (this.processedOrderData && this.processedOrderData.items) || [];
                    (grouped || []).forEach((item) => {
                        const sizes = Array.isArray(item && item.sizes) ? item.sizes : [];
                        const hasChildRows = sizes.some(
                            (s) =>
                                (parseInt(s && s.quantity, 10) || 0) > 0 &&
                                Number(s && s.parent) !== 1
                        );
                        sizes.forEach((sizeRow) => {
                            const qty = parseInt(sizeRow && sizeRow.quantity, 10) || 0;
                            if (qty <= 0) return;
                            if (hasChildRows && Number(sizeRow && sizeRow.parent) === 1) {
                                return;
                            }
                            const sizeLabel =
                                (sizeRow &&
                                    sizeRow.MainNewSubProduct &&
                                    sizeRow.MainNewSubProduct.Size &&
                                    sizeRow.MainNewSubProduct.Size.size) ||
                                (sizeRow && sizeRow.size) ||
                                "";
                            map[addrKey].push({
                                split: {
                                    split_quantity: qty,
                                    estimated_shipping_date:
                                        (sizeRow && sizeRow.estimated_shipping_date) ||
                                        item.estimated_shipping_date ||
                                        null,
                                    name_and_number_json: item.name_and_number_json
                                },
                                item,
                                sizeLabel,
                                name: "",
                                number: ""
                            });
                        });
                    });
                }
            }
            return map;
        },
        orderItemsGrouped() {
            return this.processedOrderData && this.processedOrderData.items
                ? this.processedOrderData.items
                : [];
        },
        orderItemsBaseFeeTotal() {
            return (this.orderItemsGrouped || []).reduce(
                (sum, item) => sum + (this.getBaseFeeTotal(item) || 0),
                0
            );
        },
        orderItemsRunChargeTotal() {
            return (this.orderItemsGrouped || []).reduce(
                (sum, item) => sum + (this.getRunChargeTotal(item) || 0),
                0
            );
        },
        orderItemsSetupDesignTotal() {
            return (this.orderItemsGrouped || []).reduce((sum, item) => {
                const setup = this.getSetupFeesTotal(item) || 0;
                const design = parseFloat(item && item.design_fee) || 0;
                return sum + setup + design;
            }, 0);
        },
        hasPaymentPendingId() {
            const id = this.order && this.order.payment_pending_id;
            return !!(id != null && String(id).trim());
        },
        showPendingPaymentFlow() {
            return (
                this.order &&
                (this.order.status === "PENDING AMOUNT" &&
                    this.hasPaymentPendingId)
            );
        },
        showPayNow() {
            return this.showPendingPaymentFlow && this.hasPaymentPendingId;
        },
        showPaymentMethodSection() {
            return (
                this.card_payment_details ||
                this.term_payment_details ||
                this.showPendingPaymentFlow
            );
        },
        costSummaryByAddress() {
            if (!this.processedOrderData) return null;
            return {
                baseFeeTotal: this.orderItemsBaseFeeTotal || 0,
                baseFeeLabel:
                    (this.getRollupFeeDisplayName && this.getRollupFeeDisplayName(1)) ||
                    "Base Fee",
                runChargeTotal: this.orderItemsRunChargeTotal || 0,
                runChargeLabel:
                    (this.getRollupFeeDisplayName && this.getRollupFeeDisplayName(12)) ||
                    "Run Charge",
                setupDesignTotal: this.orderItemsSetupDesignTotal || 0,
                setupDesignLabel:
                    (this.getRollupFeeDisplayName && this.getRollupFeeDisplayName(2)) ||
                    "Set Up and Design",
                packingTotal: this.getPackingKittingHandlingTotal(),
                packingBreakdown: this.getPackingKittingHandlingBreakdown() || [],
                packingLabel:
                    (this.getRollupFeeDisplayName && this.getRollupFeeDisplayName(5)) ||
                    "Packaging, Kitting and Handling",
                shippingTotal: this.getShippingTotal(),
                shippingBreakdown: this.getShippingBreakdown() || [],
                shippingLabel:
                    (this.getRollupFeeDisplayName && this.getRollupFeeDisplayName(4)) ||
                    "Shipping and Freight",
                salesTaxTotal: this.getSalesTaxTotal(),
                salesTaxBreakdown: this.getSalesTaxBreakdown() || [],
                salesTaxLabel:
                    (this.getRollupFeeDisplayName && this.getRollupFeeDisplayName(3)) ||
                    "Sales Tax",
                grandTotal: this.getGrandTotal()
            };
        }
    },
    watch: {
        showViewOrderByAddressTab(val) {
            if (!val && this.activeTab === "byAddress") {
                this.activeTab = "items";
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from && from.name === "pendingPayment") {
                vm.cleanupNavigationUiState();
                window.location.reload();
            }
        });
    },
    mounted() {
        var _this = this;
        this.cleanupNavigationUiState();

        if (_this.$route.params.id) {
            _this.getOrderDetail();
            // _this.getComments();
        }
        _this.getDecorationMethods();
        // this.getUsers();
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });

        $(function () {
            $(".acc__title").click(function (j) {
                var dropDown = $(this)
                    .closest(".acc__card")
                    .find(".acc__panel");
                $(this)
                    .closest(".acc")
                    .find(".acc__panel")
                    .not(dropDown)
                    .slideUp();

                if ($(this).hasClass("active")) {
                    $(this).removeClass("active");
                } else {
                    $(this)
                        .closest(".acc")
                        .find(".acc__title.active")
                        .removeClass("active");
                    $(this).addClass("active");
                }

                dropDown.stop(false, true).slideToggle();
                j.preventDefault();
            });
        });
        /* eslint-enable */
    },
    methods: {
        cleanupNavigationUiState() {
            document.body.classList.remove("bg_primary_light_white");
            document.body.classList.remove("modal-open");
            document.body.style.removeProperty("padding-right");
            document.body.style.removeProperty("overflow");
            $("body").find(".modal-backdrop").remove();
        },
        displayOrderStatusLabel(status) {
            if (status === "PENDING AMOUNT") {
                return "Pending Payment";
            }
            return status;
        },
        goToPendingPayment() {
            if (!this.order || !this.order.payment_pending_id) {
                return;
            }
            this.$router.push({
                name: "pendingPayment",
                params: {
                    payment_pending_id: this.order.payment_pending_id
                }
            });
        },
        /**
         * Line merge key: group_assembly_id (assembly bundle) + saved_design_id / build_id.
         * Assembly id first so non-assembly (empty) vs assembly lines never collapse together.
         */
        orderLineGroupDesignKey(row) {
            if (!row) return "|";
            const asm =
                row.group_assembly_id != null && row.group_assembly_id !== ""
                    ? String(row.group_assembly_id)
                    : "";
            if (row.saved_design_id != null && row.saved_design_id !== "")
                return asm + "|s:" + String(row.saved_design_id);
            if (row.build_id != null && row.build_id !== "")
                return asm + "|b:" + String(row.build_id);
            return asm + "|";
        },
        applyOrderAssemblyGrouping(items) {
            if (!items || items.length === 0) return items;
            // If items are already grouped (have assemblySubItems), return as-is
            if (items.some((i) => i.assemblySubItems && i.assemblySubItems.length > 0)) {
                return items;
            }
            const grouped = [];
            const keyToIndex = {};
            items.forEach((item) => {
                const groupKey = item.group_assembly_id || null;
                if (!groupKey) {
                    grouped.push(item);
                    return;
                }
                if (keyToIndex[groupKey] !== undefined) {
                    if (!grouped[keyToIndex[groupKey]].assemblySubItems) {
                        grouped[keyToIndex[groupKey]].assemblySubItems = [];
                    }
                    grouped[keyToIndex[groupKey]].assemblySubItems.push(item);
                } else {
                    item.assemblySubItems = [];
                    keyToIndex[groupKey] = grouped.length;
                    grouped.push(item);
                }
            });
            return grouped;
        },
        // ---- Fee breakdown helpers (admin parity) ----
        parseBreakdown(breakdownString) {
            if (!breakdownString) return null;
            try {
                if (typeof breakdownString === "string") {
                    return JSON.parse(breakdownString);
                }
                return breakdownString;
            } catch (e) {
                return null;
            }
        },

        // ---- Order top meta helpers (Vendor / Decorator) ----
        getOrderTopVendorNames() {
            const items = (this.order && this.order.NewOrderItems) ? this.order.NewOrderItems : [];
            const names = [];

            items.forEach((raw) => {
                const vendor = raw && raw.Vendor ? raw.Vendor : null;
                if (vendor && vendor.name) names.push(vendor.name);
            });

            const unique = [...new Set(names.filter(Boolean))];
            return unique.length ? unique.join(", ") : "—";
        },

        getOrderTopDecoratorNames() {
            const items = (this.order && this.order.NewOrderItems) ? this.order.NewOrderItems : [];
            const names = [];

            items.forEach((raw) => {
                const decorator = raw && raw.Decorator ? raw.Decorator : null;
                if (decorator && decorator.name) names.push(decorator.name);
            });

            const unique = [...new Set(names.filter(Boolean))];
            return unique.length ? unique.join(", ") : "—";
        },

        formatCarrierName(name) {
            if (!name) return "";

            const carrierMappings = {
                FedEx: "FedEx",
                fedex: "FedEx",
                FEDEX: "FedEx",
                Fedex: "FedEx",
                UPS: "UPS",
                ups: "UPS",
                USPS: "USPS",
                usps: "USPS",
                DHL: "DHL",
                dhl: "DHL"
            };

            if (carrierMappings[name]) return carrierMappings[name];

            const lowerName = String(name).toLowerCase();
            for (const [key, value] of Object.entries(carrierMappings)) {
                if (key.toLowerCase() === lowerName) return value;
            }

            if (lowerName.includes("fed") && lowerName.includes("ex")) {
                return "FedEx";
            }

            return String(name)
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(" ");
        },
        getCardImage(cardType) {
            if (!cardType) return "/maincss/images/visa_logo.png";
            const t = cardType.toLowerCase();
            if (t === "visa") return "/maincss/images/visa_logo.png";
            if (t === "mastercard" || t === "master") return "/maincss/images/master_card_logo.png";
            if (t === "amex" || t === "american express" || t === "americanexpress") return "/maincss/images/american_express_logo.svg";
            if (t === "discover") return "/maincss/images/discover_logo.png";
            if (t === "jcb") return "/maincss/images/jcb_logo.svg";
            return "/maincss/images/visa_logo.png";
        },
        getAddressShippingMethod(addresses, fallbackMethod) {
            const list = Array.isArray(addresses) ? addresses : [];
            const selected =
                list.find((a) => Number(a && a.is_default) === 1) ||
                list.find((a) => Number(a && a.split_address_sequence) === 1) ||
                list[0];
            const method =
                (selected && (selected.shipping_method || selected.ship_method || selected.shippingMethod)) ||
                "";
            return method || fallbackMethod || "";
        },
        isFedExMethod(methodName, carrierName) {
            const value = `${methodName || ""} ${carrierName || ""}`.toLowerCase();
            return value.includes("fedex") || (value.includes("fed") && value.includes("ex"));
        },
        /** shipping_option DB: '2' pickup warehouse, '3' delivery — hide FedEx logo / carrier line */
        allowShipMethodCarrierBranding(shippingOption) {
            return (
                shippingOption !== "2" &&
                shippingOption !== "3" &&
                shippingOption !== 2 &&
                shippingOption !== 3
            );
        },

        getSalesTaxBreakdown() {
            const od = this.processedOrderData;
            if (!od || !od.sales_tax_breakdown) return [];
            const breakdown = this.parseBreakdown(od.sales_tax_breakdown);
            return breakdown && Array.isArray(breakdown) ? breakdown : [];
        },
        getSalesTaxTotal() {
            const breakdown = this.getSalesTaxBreakdown();
            if (!breakdown || breakdown.length === 0) {
                const od = this.processedOrderData;
                return od && od.sales_tax ? parseFloat(od.sales_tax) || 0 : 0;
            }
            let total = 0;
            breakdown.forEach((item) => {
                if (item.total && item.total !== "INCL" && item.total !== "-") {
                    total += parseFloat(item.total) || 0;
                } else if (
                    (item.amt || item.amount) &&
                    item.amt !== "INCL" &&
                    item.amt !== "-" &&
                    item.amount !== "INCL" &&
                    item.amount !== "-"
                ) {
                    total += parseFloat(item.amt || item.amount || 0);
                }
            });
            return parseFloat(total.toFixed(2));
        },
        getShippingBreakdown() {
            const od = this.processedOrderData;
            if (!od || !od.shipping_cost_breakdown) return [];
            const breakdown = this.parseBreakdown(od.shipping_cost_breakdown);
            return breakdown && Array.isArray(breakdown) ? breakdown : [];
        },
        getShippingTotal() {
            const breakdown = this.getShippingBreakdown();
            if (!breakdown || breakdown.length === 0) {
                const od = this.processedOrderData;
                return od && od.ship_cost ? parseFloat(od.ship_cost) || 0 : 0;
            }
            let total = 0;
            breakdown.forEach((item) => {
                if (item.total && item.total !== "INCL" && item.total !== "-") {
                    total += parseFloat(item.total) || 0;
                } else if (
                    (item.amt || item.amount) &&
                    item.amt !== "INCL" &&
                    item.amt !== "-" &&
                    item.amount !== "INCL" &&
                    item.amount !== "-"
                ) {
                    total += parseFloat(item.amt || item.amount || 0);
                }
            });
            return parseFloat(total.toFixed(2));
        },
        getPackingKittingHandlingBreakdown() {
            const od = this.processedOrderData;
            if (!od || !od.packaging_kitting_handling_breakdown) return [];
            const breakdown = this.parseBreakdown(
                od.packaging_kitting_handling_breakdown
            );
            return breakdown && Array.isArray(breakdown) ? breakdown : [];
        },
        getPackingKittingHandlingTotal() {
            const breakdown = this.getPackingKittingHandlingBreakdown();
            if (!breakdown || breakdown.length === 0) return 0;
            let total = 0;
            breakdown.forEach((item) => {
                if (item.total && item.total !== "INCL" && item.total !== "-") {
                    total += parseFloat(item.total) || 0;
                } else if (
                    (item.amt || item.amount) &&
                    item.amt !== "INCL" &&
                    item.amt !== "-" &&
                    item.amount !== "INCL" &&
                    item.amount !== "-"
                ) {
                    total += parseFloat(item.amt || item.amount || 0);
                }
            });
            return parseFloat(total.toFixed(2));
        },
        getGrandTotal() {
            const od = this.processedOrderData;
            const subtotal = parseFloat((od && od.subtotal) || 0);
            const packaging = this.getPackingKittingHandlingTotal();
            const shipping = this.getShippingTotal();
            const salesTax = this.getSalesTaxTotal();
            return parseFloat((subtotal + packaging + shipping + salesTax).toFixed(2));
        },

        // ---- Item breakdown helpers (reused from payments OrderDetails) ----
        getBreakdownData(item, field) {
            if (item && item[field] !== undefined && item[field] !== null) {
                if (Array.isArray(item[field]) || typeof item[field] === "object") {
                    return item[field];
                }
                if (typeof item[field] === "string") {
                    try {
                        return JSON.parse(item[field]);
                    } catch (e) {
                        return null;
                    }
                }
                return item[field];
            }
            if (
                item &&
                item.sizes &&
                item.sizes.length > 0 &&
                item.sizes[0] &&
                item.sizes[0][field]
            ) {
                if (typeof item.sizes[0][field] === "string") {
                    try {
                        return JSON.parse(item.sizes[0][field]);
                    } catch (e) {
                        return null;
                    }
                }
                if (
                    Array.isArray(item.sizes[0][field]) ||
                    typeof item.sizes[0][field] === "object"
                ) {
                    return item.sizes[0][field];
                }
                return item.sizes[0][field];
            }
            return null;
        },
        getBaseFeeTotal(item) {
            const baseFee = this.getBreakdownData(item, "base_fee");
            if (!baseFee || !Array.isArray(baseFee)) return 0;
            let total = 0;
            baseFee.forEach((fee) => {
                if (fee && fee.total) {
                    const t = parseFloat(fee.total);
                    if (!isNaN(t)) total += t;
                }
            });
            return total;
        },
        getRunChargeTotal(item) {
            const runCharge = this.getBreakdownData(item, "run_charge_breakdown");
            if (!runCharge || !Array.isArray(runCharge)) return 0;
            let total = 0;
            runCharge.forEach((b) => {
                if (b.items && Array.isArray(b.items)) {
                    b.items.forEach((it) => {
                        if (
                            it.type === "total" &&
                            it.total &&
                            it.total !== "INCL"
                        ) {
                            total += parseFloat(it.total) || 0;
                        } else if (
                            it.total &&
                            it.total !== "INCL" &&
                            !it.isIncluded
                        ) {
                            total += parseFloat(it.total) || 0;
                        }
                    });
                }
                if (b.type === "otherService" && b.total && b.total !== "INCL") {
                    total += parseFloat(b.total) || 0;
                }
            });
            return total;
        },
        getSetupFeesTotal(item) {
            const setupFees = this.getBreakdownData(item, "setup_fees_details");
            if (!setupFees || typeof setupFees !== "object") return 0;
            return setupFees.total ? parseFloat(setupFees.total) || 0 : 0;
        },
        /** Normalize name_and_number_json to array for display. Supports legacy array and new object { front, back, left, right }. */
        normalizeNameAndNumberJson(raw) {
            if (!raw) return [];
            let parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
            if (Array.isArray(parsed)) {
                return parsed.filter(
                    (nn) =>
                        nn &&
                        (String(nn.name || "").trim() !== "" ||
                            String(nn.number || "").trim() !== "")
                );
            }
            if (
                parsed &&
                typeof parsed === "object" &&
                !Array.isArray(parsed)
            ) {
                const keys = ["front", "back", "left", "right"];
                let arr = [];
                keys.forEach((k) => {
                    if (Array.isArray(parsed[k])) arr = arr.concat(parsed[k]);
                });
                return arr.filter(
                    (nn) =>
                        nn &&
                        (String(nn.name || "").trim() !== "" ||
                            String(nn.number || "").trim() !== "")
                );
            }
            return [];
        },
        existsNameAndNumber(data, type) {
            if (!data || !Array.isArray(data)) return false;
            return data.some(
                (nn) => nn && String(nn[type] || "").trim() !== ""
            );
        },
        focusOnEditor() {
            this.$refs.editor.instance.focus();
            document.getElementById("ckeditor").scrollIntoView();
        },
        filterQty(qty) {
            if (qty) {
                return qty.filter((element) => element.qty > 0);
            }
            return [];
        },
        getUsers() {
            var _this = this;
            ApiService.get("/super-users")
                .then(({ data }) => {
                    _this.users = data.users;
                })
                .catch(({ response }) => {
                    console.log(response);
                    if (response.status == 401) {
                        _this.$router.push({ name: "/admin/login" });
                    }
                });
        },
        addComment() {
            var _this = this;
            _this.$validator.validateAll("addcommentform").then((isValid) => {
                _this.isSubmit = true;
                if (isValid) {
                    _this.isBusy = true;
                    ApiService.post("/comments", _this.comment)
                        .then(({ data }) => {
                            _this.getComments();
                            if (data.success) {
                                _this.comment = {
                                    message: "",
                                    user_to: null,
                                    order_id: this.$route.params.id
                                };
                                _this.isBusy = false;
                                _this.$toast.success(
                                    "Comment added successfully",
                                    {
                                        position: "top-right"
                                    }
                                );
                                setTimeout(() => {
                                    _this.$validator.reset();
                                }, 0);
                            }
                            _this.isBusy = false;
                        })
                        .catch(({ response }) => {
                            if (response.status == 401) {
                                _this.$router.push({ name: "/admin/login" });
                            }
                            _this.isBusy = false;
                        });
                } else {
                    console.log("gjhghj", _this.errors);
                }
            });
        },
        getDesignCost(imprint) {
            // console.log(imprint);
            if (imprint) {
                return imprint.reduce((cost, element) => {
                    if (element.is_selected) {
                        const sum = element.colors.reduce(function (
                            total,
                            number
                        ) {
                            return total + parseFloat(number.color_cost);
                        },
                        0);
                        return cost + parseFloat(sum);
                    } else {
                        return cost;
                    }
                }, 0);
            }
            return 0.0;
        },
        getArtwork(art) {
            let display_text = "";
            if (art) {
                let artwork;
                try {
                    artwork = JSON.parse(JSON.parse(art));
                } catch (error) {
                    console.log(error);
                }

                if (artwork.decoration_type == 1) {
                    display_text = "Print";
                } else if (artwork.decoration_type == 2) {
                    display_text = "Embroidery";
                } else if (artwork.decoration_type == 3) {
                    display_text = "Promotional";
                }
            }
            return display_text;
        },
        getComments() {
            var _this = this;
            _this.isBusy = true;
            new Promise(() => {
                ApiService.post("/item-comments", { order_id: _this.order_id })
                    .then(({ data }) => {
                        _this.comment_list = data.comments;
                        _this.isBusy = false;
                    })
                    .catch(({ response }) => {
                        _this.isBusy = false;
                        // console.log(response, "aaaa");
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        getOrderDetail() {
            var _this = this;
            _this.isBusy = true;
            new Promise((resolve) => {
                ApiService.get("/neworderdetail/" + _this.order_id)
                    .then(({ data }) => {
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            this.isBusy = false;
                            return;
                        }
                        let order = data.order;
                        if (
                            !order ||
                            order.User.id != this.currentUserClient.id
                        ) {
                            this.$router.replace({ name: "404" });
                            return;
                        }

                        // Actual Payment
                        let term_payment_details = order.NewOrderPayments.find(
                            (payment) => payment.type == "termPayment"
                        );
                        if (
                            term_payment_details &&
                            term_payment_details.payment_details
                        ) {
                            term_payment_details.payment_details =
                                term_payment_details.payment_details
                                    ? JSON.parse(
                                          term_payment_details.payment_details
                                      )
                                    : null;
                        }
                        this.term_payment_details = term_payment_details;

                        let card_payment_details = order.NewOrderPayments.find(
                            (payment) => payment.type == "credit card"
                        );
                        if (
                            card_payment_details &&
                            card_payment_details.payment_details
                        ) {
                            card_payment_details.payment_details =
                                card_payment_details.payment_details
                                    ? JSON.parse(
                                          card_payment_details.payment_details
                                      )
                                    : null;
                        }
                        this.card_payment_details = card_payment_details;

                        // ADDITIONAL PAYMENT
                        let additional_term_payment =
                            order.NewOrderPayments.find(
                                (payment) =>
                                    payment.type == "termPayment" &&
                                    payment.is_additional_payment == 1
                            );
                        if (
                            additional_term_payment &&
                            additional_term_payment.payment_details
                        ) {
                            additional_term_payment.payment_details =
                                additional_term_payment.payment_details
                                    ? JSON.parse(
                                          additional_term_payment.payment_details
                                      )
                                    : null;
                        }
                        this.additional_term_payment = additional_term_payment;
                        if (
                            this.additional_term_payment &&
                            this.additional_term_payment.payment_details &&
                            this.additional_term_payment.payment_details.prices
                        ) {
                            this.additional_payment =
                                this.additional_term_payment.payment_details.prices;
                        }

                        let additional_card_payment =
                            order.NewOrderPayments.find(
                                (payment) =>
                                    payment.type == "credit card" &&
                                    payment.is_additional_payment == 1
                            );
                        if (
                            additional_card_payment &&
                            additional_card_payment.payment_details
                        ) {
                            additional_card_payment.payment_details =
                                additional_card_payment.payment_details
                                    ? JSON.parse(
                                          additional_card_payment.payment_details
                                      )
                                    : null;
                        }
                        this.additional_card_payment = additional_card_payment;
                        if (
                            this.additional_card_payment &&
                            this.additional_card_payment.payment_details &&
                            this.additional_card_payment.payment_details.prices
                        ) {
                            this.additional_payment =
                                this.additional_card_payment.payment_details.prices;
                        }

                        let obj = order.payment_data;
                        _this.payment_detail_myJSON = JSON.parse(obj);
                        //order fees
                        let order_fees = data.order.OrderReviewFees;

                        if (order_fees) {
                            order_fees.forEach((fees) => {
                                if (fees.decoration_title == null) {
                                    this.order_fees.push({
                                        decoration_title: "Order Fee",
                                        decoration_fee: fees.decoration_fee
                                    });
                                } else {
                                    this.order_fees.push({
                                        decoration_title: fees.decoration_title,
                                        decoration_fee: fees.decoration_fee
                                    });
                                }
                            });
                        }
                        // Address
                        let order_addresses = data.order.NewOrderAddresses;
                        if (order_addresses) {
                            let billing_address = order_addresses.find(
                                (address) => address.is_billing
                            );
                            let shipping_address = order_addresses.find(
                                (address) => address.is_shipping
                            );
                            if (billing_address) {
                                this.billing_address = {
                                    first_name: billing_address.first_name,
                                    last_name: billing_address.last_name,
                                    address_label: billing_address.company_name,
                                    address1: billing_address.address_line1,
                                    address2: billing_address.address_line2,
                                    city: billing_address.city,
                                    state: billing_address.state,
                                    country: billing_address.country,
                                    zip: billing_address.zip,
                                    phone: billing_address.phone,
                                    email: billing_address.email
                                };
                                if (!shipping_address) {
                                    this.shipping_address =
                                        this.billing_address;
                                }
                            }

                            if (shipping_address) {
                                this.shipping_address = {
                                    first_name: shipping_address.first_name,
                                    last_name: shipping_address.last_name,
                                    shippingaddress_label:
                                        shipping_address.company_name,
                                    address1: shipping_address.address_line1,
                                    address2: shipping_address.address_line2,
                                    city: shipping_address.city,
                                    state: shipping_address.state,
                                    country: shipping_address.country,
                                    zip: shipping_address.zip,
                                    phone: shipping_address.phone,
                                    email: shipping_address.email
                                };
                                if (!billing_address) {
                                    this.billing_address =
                                        this.shipping_address;
                                }
                            }
                        }
                        let order_items = [];
                        let all_setup_fee = 0;
                        let subtotal = 0;
                        let total_discount = 0;
                        let front_art_url;
                        let total_non_standard_colors = [];

                        data.order.NewOrderItems.forEach((item) => {
                            const productSource =
                                item &&
                                item.MainNewSubProduct &&
                                (item.MainNewSubProduct.MainNewProducts ||
                                    item.MainNewSubProduct.MainNewProduct);
                            if (item.MainNewSubProduct && productSource) {
                                let item_setup_fee = 0;
                                // Create a copy of product data to preserve all properties
                                let order_item = {
                                    ...(productSource || {})
                                };
                                // Ensure essential properties are preserved
                                // IMPORTANT: our grouping logic below matches by parent_product_id,
                                // so force a stable id for grouping (prevents duplicates when API returns MainNewProduct vs MainNewProducts).
                                order_item.id = item.MainNewSubProduct.parent_product_id;
                                order_item.product_number =
                                    productSource.product_number ||
                                    order_item.product_number ||
                                    item.MainNewSubProduct.parent_product_id ||
                                    "";
                                order_item.name =
                                    productSource.name ||
                                    productSource.product_number ||
                                    order_item.name ||
                                    order_item.product_number ||
                                    "Product";
                                order_item.Vendor =
                                    (item.MainNewSubProduct.MainNewProducts && item.MainNewSubProduct.MainNewProducts.Vendor) ||
                                    (item.MainNewSubProduct.MainNewProduct && item.MainNewSubProduct.MainNewProduct.Vendor) ||
                                    null;
                                order_item.gender_size_id = item.gender_size_id;
                                order_item.unique_item_id = item.unique_item_id;
                                order_item.color = item.MainNewSubProduct.Color;
                                order_item["NewOrderItemDecoration"] =
                                    item.NewOrderItemDecoration;
                                const groupParentId =
                                    item.MainNewSubProduct.parent_product_id;
                                const groupColorId =
                                    item.MainNewSubProduct.color_id;
                                const groupDesignKey =
                                    this.orderLineGroupDesignKey(item);
                                const groupUniqueItemId =
                                    item.unique_item_id != null
                                        ? String(item.unique_item_id)
                                        : "";
                                let index = order_items.findIndex((item_data) => {
                                    if (
                                        !item_data ||
                                        !item_data.color ||
                                        item_data.id != groupParentId ||
                                        item_data.color.id != groupColorId
                                    ) {
                                        return false;
                                    }
                                    const existingUniqueItemId =
                                        item_data.unique_item_id != null
                                            ? String(item_data.unique_item_id)
                                            : "";
                                    return (
                                        this.orderLineGroupDesignKey(
                                            item_data
                                        ) === groupDesignKey &&
                                        existingUniqueItemId ===
                                            groupUniqueItemId
                                    );
                                });
                                item_setup_fee =
                                    item_setup_fee + parseFloat(item.setup_fee);

                                // Track discount for subtotal calculation
                                if (item.discount) {
                                    total_discount += parseFloat(
                                        item.discount || 0
                                    );
                                }
                                if (index >= 0 && order_items[index]) {
                                    const hasIncomingNameNumber =
                                        item.name_and_number_json != null &&
                                        item.name_and_number_json !== "";
                                    const currentNameNumber =
                                        order_items[index].name_and_number_json;
                                    const currentNameNumberEmpty =
                                        currentNameNumber == null ||
                                        currentNameNumber === "" ||
                                        (Array.isArray(currentNameNumber) &&
                                            currentNameNumber.length === 0);
                                    if (
                                        hasIncomingNameNumber &&
                                        currentNameNumberEmpty
                                    ) {
                                        order_items[index][
                                            "name_and_number_json"
                                        ] = this.normalizeNameAndNumberJson(
                                            item.name_and_number_json
                                        );
                                    }
                                    order_items[index]["sizes"].push(item);
                                    order_items[index]["total_quantity"] +=
                                        item.quantity;
                                    order_items[index]["total_price"] +=
                                        parseFloat(item.total_price) +
                                        parseFloat(item.discount);
                                    order_items[index]["total_discount"] +=
                                        parseFloat(item.discount);
                                    order_items[index]["total_extra_fees"] +=
                                        parseFloat(
                                            item["single_location_price"]
                                        ) * parseFloat(item["quantity"]);
                                    order_items[index][
                                        "total_single_location_price"
                                    ] +=
                                        parseFloat(item.single_location_price) *
                                        parseFloat(item["quantity"]);

                                    // For grouped items, sum item_sub_total from all sizes
                                    if (item.item_sub_total) {
                                        if (
                                            !order_items[index][
                                                "item_sub_total"
                                            ]
                                        ) {
                                            order_items[index][
                                                "item_sub_total"
                                            ] = 0;
                                        }
                                        order_items[index]["item_sub_total"] +=
                                            parseFloat(
                                                item.item_sub_total || 0
                                            );
                                    }

                                    // Copy breakdown fields from first size if not already set
                                    if (
                                        !order_items[index]["base_fee"] &&
                                        item.base_fee
                                    ) {
                                        order_items[index]["base_fee"] =
                                            typeof item.base_fee === "string"
                                                ? JSON.parse(item.base_fee)
                                                : item.base_fee;
                                    }
                                    if (
                                        !order_items[index][
                                            "run_charge_breakdown"
                                        ] &&
                                        item.run_charge_breakdown
                                    ) {
                                        order_items[index][
                                            "run_charge_breakdown"
                                        ] =
                                            typeof item.run_charge_breakdown ===
                                            "string"
                                                ? JSON.parse(
                                                      item.run_charge_breakdown
                                                  )
                                                : item.run_charge_breakdown;
                                    }
                                    if (
                                        !order_items[index][
                                            "rush_fee_breakdown"
                                        ] &&
                                        item.rush_fee_breakdown
                                    ) {
                                        order_items[index][
                                            "rush_fee_breakdown"
                                        ] =
                                            typeof item.rush_fee_breakdown ===
                                            "string"
                                                ? JSON.parse(
                                                      item.rush_fee_breakdown
                                                  )
                                                : item.rush_fee_breakdown;
                                    }
                                    if (
                                        !order_items[index][
                                            "setup_fees_details"
                                        ] &&
                                        item.setup_fees_details
                                    ) {
                                        order_items[index][
                                            "setup_fees_details"
                                        ] =
                                            typeof item.setup_fees_details ===
                                            "string"
                                                ? JSON.parse(
                                                      item.setup_fees_details
                                                  )
                                                : item.setup_fees_details;
                                    }
                                    // Copy decoration from first size for grouped items (for Decoration Service display)
                                    if (
                                        !order_items[index]["decoration"] &&
                                        item.decoration
                                    ) {
                                        order_items[index]["decoration"] =
                                            typeof item.decoration === "string"
                                                ? JSON.parse(item.decoration)
                                                : item.decoration;
                                    }
                                    if (
                                        !order_items[index][
                                            "custom_color_fee"
                                        ] &&
                                        item.custom_color_fee
                                    ) {
                                        order_items[index]["custom_color_fee"] =
                                            typeof item.custom_color_fee ===
                                            "string"
                                                ? JSON.parse(
                                                      item.custom_color_fee
                                                  )
                                                : item.custom_color_fee;
                                    }
                                    if (
                                        !order_items[index][
                                            "patch_cost_details"
                                        ] &&
                                        item.patch_cost_details
                                    ) {
                                        order_items[index][
                                            "patch_cost_details"
                                        ] =
                                            typeof item.patch_cost_details ===
                                            "string"
                                                ? JSON.parse(
                                                      item.patch_cost_details
                                                  )
                                                : item.patch_cost_details;
                                    }
                                    if (
                                        !order_items[index]["patch_cost"] &&
                                        parseFloat(item.patch_cost || 0) > 0
                                    ) {
                                        order_items[index]["patch_cost"] =
                                            parseFloat(item.patch_cost || 0);
                                    }
                                    if (
                                        !order_items[index][
                                            "font_color_sizes_name"
                                        ] &&
                                        item.font_color_sizes_name
                                    ) {
                                        order_items[index][
                                            "font_color_sizes_name"
                                        ] = item.font_color_sizes_name;
                                    }
                                    if (
                                        !order_items[index][
                                            "font_color_sizes_number"
                                        ] &&
                                        item.font_color_sizes_number
                                    ) {
                                        order_items[index][
                                            "font_color_sizes_number"
                                        ] = item.font_color_sizes_number;
                                    }
                                } else {
                                    order_item["sizes"] = [item];

                                    order_item["total_quantity"] =
                                        item.quantity;
                                    order_item["setup_fee"] = item_setup_fee;
                                    order_item["total_price"] =
                                        parseFloat(item.total_price) +
                                        parseFloat(item.discount);
                                    order_item["total_discount"] = parseFloat(
                                        item.discount
                                    );
                                    order_item["design_fee"] = parseFloat(
                                        item.design_fee
                                    );
                                    order_item["patch_cost"] = parseFloat(
                                        item.patch_cost || 0
                                    );
                                    order_item["patch_cost_details"] = item.patch_cost_details
                                        ? (typeof item.patch_cost_details === "string"
                                            ? JSON.parse(item.patch_cost_details)
                                            : item.patch_cost_details)
                                        : null;
                                    order_item["name_number_fees"] = parseFloat(
                                        item.name_number_fees
                                    );
                                    order_item["non_standard_fees"] =
                                        parseFloat(item.non_standard_fees);
                                    order_item["item_sub_total"] =
                                        item.item_sub_total
                                            ? parseFloat(item.item_sub_total)
                                            : null;

                                    // Copy breakdown fields from item to order_item
                                    order_item["base_fee"] = item.base_fee
                                        ? typeof item.base_fee === "string"
                                            ? JSON.parse(item.base_fee)
                                            : item.base_fee
                                        : [];
                                    order_item["run_charge_breakdown"] =
                                        item.run_charge_breakdown
                                            ? typeof item.run_charge_breakdown ===
                                              "string"
                                                ? JSON.parse(
                                                      item.run_charge_breakdown
                                                  )
                                                : item.run_charge_breakdown
                                            : [];
                                    order_item["rush_fee_breakdown"] =
                                        item.rush_fee_breakdown
                                            ? typeof item.rush_fee_breakdown ===
                                              "string"
                                                ? JSON.parse(
                                                      item.rush_fee_breakdown
                                                  )
                                                : item.rush_fee_breakdown
                                            : null;
                                    order_item["setup_fees_details"] =
                                        item.setup_fees_details
                                            ? typeof item.setup_fees_details ===
                                              "string"
                                                ? JSON.parse(
                                                      item.setup_fees_details
                                                  )
                                                : item.setup_fees_details
                                            : null;
                                    order_item["custom_color_fee"] =
                                        item.custom_color_fee
                                            ? typeof item.custom_color_fee ===
                                              "string"
                                                ? JSON.parse(
                                                      item.custom_color_fee
                                                  )
                                                : item.custom_color_fee
                                            : [];

                                    order_item["non_standard_colors"] =
                                        item.non_standard_colors
                                            ? JSON.parse(
                                                  item.non_standard_colors
                                              )
                                            : [];
                                    order_item["decoration_colors"] =
                                        item.decoration_colors
                                            ? JSON.parse(item.decoration_colors)
                                            : [];
                                    order_item["decoration"] = item.decoration
                                        ? typeof item.decoration === "string"
                                            ? JSON.parse(item.decoration)
                                            : item.decoration
                                        : null;
                                    // order_item.artwork_colors = [...new Set(order_item.standard_colors.concat(order_item.non_standard_colors))];
                                    total_non_standard_colors =
                                        total_non_standard_colors.concat(
                                            order_item["non_standard_colors"]
                                        );
                                    order_item["imprint_locations"] =
                                        item.imprint_locations
                                            ? JSON.parse(item.imprint_locations)
                                            : [];
                                    order_item["imprint_locations"] =
                                        order_item["imprint_locations"].filter(
                                            (imprint_location) =>
                                                imprint_location.is_selected
                                        );
                                    order_item["color_fee"] = 0;

                                    // Handle product images with proper null checks
                                    if (
                                        order_item.MainNewProductsImages &&
                                        Array.isArray(
                                            order_item.MainNewProductsImages
                                        ) &&
                                        order_item.MainNewProductsImages
                                            .length > 0
                                    ) {
                                        order_item["product_image"] =
                                            order_item.MainNewProductsImages.find(
                                                (image) =>
                                                    image.color_id ==
                                                    order_item.color.id
                                            );
                                        if (!order_item["product_image"]) {
                                            order_item["product_image"] =
                                                order_item.MainNewProductsImages[0];
                                        }
                                    } else {
                                        order_item["product_image"] = null;
                                    }

                                    // order_item['design_image'] = JSON.parse(item.design_image)[0]['url'];
                                    order_item["build_id"] = item.build_id;
                                    order_item["saved_design_id"] =
                                        item.saved_design_id;
                                    order_item["group_assembly_id"] = item.group_assembly_id || null;
                                    order_item["design_area_inches"] = item.design_area_inches != null ? item.design_area_inches : null;
                                    order_item["design_images"] =
                                        item.design_image
                                            ? JSON.parse(item.design_image)
                                            : [];
                                    if (
                                        order_item["design_images"] &&
                                        order_item["design_images"].length > 0
                                    ) {
                                        order_item["design_image"] = JSON.parse(
                                            item.design_image
                                        )[0]["url"];
                                        if (
                                            front_art_url !=
                                            order_item["design_images"][0][
                                                "design_image"
                                            ]
                                        ) {
                                            order_item["front_art_url"] =
                                                order_item["design_images"][0][
                                                    "design_image"
                                                ];
                                            front_art_url =
                                                order_item["front_art_url"];
                                        }

                                        if (item.OrderBuild) {
                                            order_item["OrderBuild"] =
                                                item.OrderBuild;
                                        }
                                    }
                                    // console.log('check all design for images here=================================', order_item['design_images']);
                                    order_item["name_and_number_json"] =
                                        this.normalizeNameAndNumberJson(
                                            item.name_and_number_json
                                        );
                                    order_item["font_color_sizes_name"] =
                                        item.font_color_sizes_name != null &&
                                        item.font_color_sizes_name !== ""
                                            ? item.font_color_sizes_name
                                            : null;
                                    order_item["font_color_sizes_number"] =
                                        item.font_color_sizes_number != null &&
                                        item.font_color_sizes_number !== ""
                                            ? item.font_color_sizes_number
                                            : null;
                                    order_item["imprint_locations"].forEach(
                                        (location) => {
                                            order_item["color_fee"] +=
                                                parseFloat(
                                                    location[
                                                        "total_decoration_fee"
                                                    ]
                                                );
                                            if (location.is_selected) {
                                                location.colors.forEach(
                                                    (color) => {
                                                        //     if (color.decor_upcharge) {
                                                        //         order_item['color_fee']+=parseFloat(color.decor_upcharge.color_cost) + parseFloat(color.cost_cost);
                                                        //     } else {
                                                        //         order_item['color_fee']+=parseFloat(color.cost_cost);
                                                        //     }
                                                        order_item[
                                                            "color_fee"
                                                        ] += parseFloat(
                                                            color.total_decor_upcharge
                                                        );
                                                    }
                                                );
                                            }
                                        }
                                    );

                                    order_item["total_single_location_price"] =
                                        parseFloat(
                                            item["single_location_price"]
                                        ) * parseFloat(item["quantity"]);

                                    order_item["total_extra_fees"] =
                                        parseFloat(item["design_fee"]) +
                                        parseFloat(order_item["color_fee"]) +
                                        parseFloat(
                                            item["single_location_price"]
                                        ) *
                                            parseFloat(item["quantity"]);

                                    subtotal += parseFloat(
                                        order_item.color_fee
                                    );
                                    order_items.push(order_item);
                                }
                                all_setup_fee = all_setup_fee + item_setup_fee;
                            }
                        });

                        // PRICE BREAKUPS
                        order_items.forEach((order_item) => {
                            order_item.base_price = 0;
                            order_item.markup_price = 0;
                            order_item.markup_percentage = 0;
                            order_item.ink_price = 0;
                            order_item.single_location_price = 0;
                            order_item.sizes.forEach((size) => {
                                order_item.base_price +=
                                    parseFloat(size.base_price) *
                                    parseInt(size.quantity);
                                order_item.ink_price += parseFloat(
                                    size.ink_price
                                );
                                order_item.single_location_price = parseFloat(
                                    size.single_location_price
                                );
                                order_item.markup_price +=
                                    parseFloat(size.markup_price) *
                                    parseInt(size.quantity);
                                order_item.markup_percentage =
                                    size.markup_percentage;
                            });
                            // order_item.base_price = order_item.base_price * parseInt(order_item.total_quantity)
                            order_item.ink_price =
                                parseFloat(order_item.ink_price) *
                                parseInt(order_item.total_quantity);
                            order_item.single_location_price =
                                parseFloat(order_item.single_location_price) *
                                parseInt(order_item.total_quantity);
                            // order_item.markup_price = order_item.markup_price * order_item.total_quantity;
                        });

                        // Calculate subtotal from item_sub_total (like OrderDetails component)
                        subtotal = 0;
                        let calculated_total_discount = 0;
                        order_items.forEach((order_item) => {
                            if (order_item.item_sub_total) {
                                subtotal += parseFloat(
                                    order_item.item_sub_total
                                );
                            } else {
                                // Fallback to old calculation if item_sub_total is not available
                                subtotal += parseFloat(
                                    order_item.total_price || 0
                                );
                            }
                            // Calculate total discount from all sizes in this item
                            if (
                                order_item.sizes &&
                                Array.isArray(order_item.sizes)
                            ) {
                                order_item.sizes.forEach((size) => {
                                    if (size.discount) {
                                        calculated_total_discount += parseFloat(
                                            size.discount || 0
                                        );
                                    }
                                });
                            } else if (order_item.total_discount) {
                                // Fallback: use total_discount if available
                                calculated_total_discount += parseFloat(
                                    order_item.total_discount || 0
                                );
                            }
                        });

                        // Subtract total discount from subtotal
                        order.subtotal = subtotal - calculated_total_discount;

                        order.NewOrderItems = order_items;
                        order.total_setup_fee = all_setup_fee;

                        // Prepare data for OrderDetails component
                        // OrderDetails expects order_detail.items instead of NewOrderItems
                        let processedOrder = JSON.parse(JSON.stringify(order));
                        processedOrder.items = order_items;

                        _this.order = order;
                        _this.processedOrderData = processedOrder;
                        _this.total_non_standard_colors = [
                            ...new Set(total_non_standard_colors)
                        ];
                        _this.isBusy = false;
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        _this.isBusy = false;
                        // reject(response);
                    });
            });
        },
        getShippingStateAndZipCode(id, address = "billing_full_address") {
            var _this = this;
            new Promise(() => {
                ApiService.post("/getstateandzipcode/" + id)
                    .then(({ data }) => {
                        _this.$set(
                            _this.order_id,
                            address,
                            data.zipAndState.complete_address
                        );
                    })
                    .catch(({ response }) => {
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        productColors(color) {
            if (color) {
                let style = color.swatches
                    ? "background-image:url(" + color.swatches + ")"
                    : " background-color:" + color.hex;

                let html =
                    `  <a href="javascript:void(0)"
                             class="color_circle mr_16 bg_secondary_black "
                             style="` +
                    style +
                    `"></a>`;
                return html;
            }
            return "";
        },
        converToCamel(text) {
            return text.replace(
                /(^\w|\s\w)(\S*)/g,
                (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
            );
        },
        openCostPopup() {
            /* eslint-disable */
            $(function () {
                $(".cart_tbl_mobile").addClass("set-popup-size");
                $(document).on("click", function (e) {
                    if ($(e.target).is(".cart_tbl_mobile") === false) {
                        $(".cart_tbl_mobile").removeClass("set-popup-size");
                    }
                });
            });
            /* eslint-enable */
        },
        downloadArtwork(uri, name) {
            var link = document.createElement("a");
            link.download = name;
            link.href = uri;
            link.target = "_blank";
            if (!uri) {
                link.href = "/maincss/images/mug_2.png";
            }
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        getDecorationMethods() {
            return new Promise((resolve, reject) => {
                ApiService.get("/decoration-methods")
                    .then(({ data }) => {
                        this.decoration_methods = data.decoration_methods;
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getDecorationMethodName(type) {
            if (!this.decoration_methods) {
                return "";
            }
            let decoration_data = this.decoration_methods.find(
                (method) => method.id == type
            );
            if (decoration_data) {
                return decoration_data.name;
            }

            return "";
        },
        showDesignImages(data) {
            if (data) {
                let json = data;
                json = json.filter((img) => img.canvas_images.length > 0);
                if (json.length > 0) {
                    return true;
                }
            }
            return false;
        },

        hasLimit(item, index) {
            if (!item.is_color_show_more) {
                return index < this.colors_limit;
            }
            return true;
        },

        getBase64Image() {
            var request = require("request").defaults({ encoding: null });
            const baseImageUrl = process.env.VUE_APP_BASE_IMAGE_URL;
            const imageUrl = `${baseImageUrl}/6374.png`;

            request.get(imageUrl, function (error, response, body) {
                if (!error && response.statusCode == 200) {
                    let data =
                        "data:" +
                        response.headers["content-type"] +
                        ";base64," +
                        Buffer.from(body).toString("base64");
                    console.log(data);
                }
            });
        },

        with2Decimals(num) {
            // this.$with2Decimals(num);
            var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
            return parseFloat(with2Decimals);
        }
    },
    filters: {
        productTitleExceed(value) {
            if (!value) {
                return "";
            }
            return value.substring(0, 50) + "....";
        }
    }
};
</script>
<style>
.order_detail_left_panel .acc__panel {
    padding: 0px
}

.order-tabs-wrapper .tabs-block {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    background: #FFF;
    box-shadow: 0 1px 15px 0 rgba(62, 57, 107, 0.07);
    border-bottom: none;
}

.order-tabs-headings-row {
    display: flex;
    width: 100%;
    padding: 24px 24px 0px 35px;
}

.order-tabs-heading-left {
    flex: 0 0 66.6667%;
    font-family: 'Mulish';
    font-size: 20px;
    line-height: 20px;
    font-weight: 700;
    color: #121212;
}

.order-tabs-heading-right {
    flex: 0 0 33.3333%;
    font-family: 'Mulish';
    font-size: 20px;
    font-weight: 700;
    color: #121212;
}

.order-tabs-wrapper .tabs-block ul {
    display: flex;
    padding: 12px 24px 0 24px;
    border-bottom: 1px solid #D1D1D1;
    margin-bottom: 0;
    list-style: none;
}

.order-tabs-wrapper .tabs-block ul li {
    list-style: none;
    margin-right: 0;
}

.order-tabs-wrapper .tabs-block ul li a {
    display: inline-block;
    background-color: transparent !important;
    color: #606060 !important;
    font-family: 'Mulish';
    font-size: 14px;
    font-weight: 600;
    line-height: 14px;
    letter-spacing: -0.315px;
    box-shadow: none !important;
    padding: 8px 8px 16px 8px !important;
    border-radius: 0 !important;
    text-decoration: none;
    border-bottom: 2px solid transparent;
}

.order-tabs-wrapper .tabs-block ul li a.active {
    color: #1D6CB5 !important;
    font-weight: 700 !important;
    border-bottom: 2px solid #006FAC !important;
}

.image-button-design {
    font-size: 15px;
    letter-spacing: 1.73px;
    text-align: center;
    color: #0079c1 !important;
    padding: 16px 26px;
    min-width: 100px !important;
    border-color: #0079c1 !important;
    text-transform: uppercase;
    background: #fff;
    margin-top: 10px;
    border-radius: 4px;
}
.cart_modal_s-img {
    max-width: 1400px;
}
.cart_modal_s-img .product_details-cart {
    margin: 0 !important;
    padding: 10px !important;
    max-width: 224px;
    max-height: 303px;
    height: 100%;
    min-height: 194px;
}
.cart_modal_s-img .product_details-cart .choice_img {
    border: 1px solid #000;
    padding: 0;
    min-height: 200px;
    display: flex;
    -webkit-box-align: baseline;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
}
.cart_modal_s-img .product_details-cart .choice_img img {
    width: 100%;
    height: auto;
    max-height: 130px;
    padding: 5px;
    max-width: 100%;
    object-fit: contain;
}
.cart_modal_s-img .product_details-cart .choice_img .order_shape_title {
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.7294117647);
    background-color: #ececec;
    width: 90%;
    text-transform: capitalize;
    padding: 4px;
    line-height: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    position: absolute;
    bottom: 4px;
}
.cart_modal_s-img .product_details-cart .choice_img .dimension_text {
    position: absolute;
    top: 11px;
    right: 11px;
    font-size: 15px;
    font-weight: 600;
    background-color: #ececec;
    width: 90%;
    text-align: center;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.cart_modal_s-img .main_title {
    margin-left: 10px;
}
.cart_modal_s-img .image-align-col {
    margin-left: 0px;
}
.cart_modal_s-img .main_title h5 {
    color: #000 !important;
}
.cart_modal_s-img .modal-scroll {
    overflow: auto;
    max-height: 600px;
}
/* ================================
   Order header meta (Vendor/Decorator)
   ================================ */
.order_detail_left_panel .order_details_top_meta_strip {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 6px;
}

.order_detail_left_panel .order_details_meta_grid {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 34px;
    flex-wrap: wrap;
}

.order_detail_left_panel .order_details_meta_item {
    min-width: 160px;
}

.order_detail_left_panel .order_details_meta_label {
    font-size: 13px;
    color: #6b7280;
    font-weight: 700;
    line-height: 14px;
    margin-bottom: 4px;
}

.order_detail_left_panel .order_details_meta_value {
    font-size: 13px;
    color: #1D6CB5;
    font-weight: 500;
    line-height: 16px;
    word-break: break-word;
}

.order_detail_left_panel .order_details_note_bar {
    background: #FFCC004D;
    padding: 8px;
    font-size: 14px;
    color: #414141;
    margin-top: 16px;
    font-style: italic;
}

/* Header alignment + key-value rows (matches admin OrderDetails header card) */
.order_detail_left_panel .order_details_header_row {
    margin-top: 10px;
    border-top: 1px solid #E5E7EB;
    padding-top: 20px;
}

.order_detail_left_panel .order_details_card_boady_custom {
    position: relative;
}

.order_detail_left_panel .heading_label {
    font-size: 16px;
    color: #121212;
    font-weight: 700;
    line-height: 16px;
    font-family: 'Mulish';
    letter-spacing: -0.288px;
    margin-bottom: 16px;
    text-transform: uppercase;
}

.order_detail_left_panel .shipping-method-wrap .shipping-method-carrier {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
}

.order_detail_left_panel .shipping-method-wrap .shipping-method-logo {
    width: 54px;
    height: 15px;
    object-fit: contain;
    display: inline-block;
    flex-shrink: 0;
}

.order_detail_left_panel .shipping-method-wrap .shipping-method-name {
    font-size: 14px;
    color: #414141;
    font-weight: 400;
}

.order_detail_left_panel .payment-method-card-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 6px;
}

.order_detail_left_panel .payment-card-logo {
    height: 24px; 
    width: 35px;
    object-fit: contain;
    flex-shrink: 0;
}

.order_detail_left_panel .payment-card-number {
    font-size: 14px;
    color: #121212;
    font-weight: 500;
}

.order_detail_left_panel .payment-amount-row {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #414141;
}

.order_detail_left_panel .payment-amount-label {
    font-weight: 500;
    color: #121212;
}

.order_detail_left_panel .payment-amount-value {
    font-weight: 700;
    color: #121212;
    font-size: 16px;
}

.order_detail_left_panel .order_kv_row {
    display: flex;
    align-items: flex-start;
    gap: 0;
}

.order_detail_left_panel .order_kv_label {
    display: flex;
    align-items: flex-start;
    flex: 0 0 135px;
    white-space: nowrap;
}

.order_detail_left_panel .order_kv_label_text {
    flex: 0 0 130px;
    white-space: nowrap;
    font-weight: 500;
    color: #121212;
    font-size: 14px;
}

.order_detail_left_panel .order_kv_colon {
    flex: 0 0 10px;
    white-space: nowrap;
    font-weight: 700;
}

.order_detail_left_panel .order_kv_value {
    flex: 1;
    min-width: 0;
    margin-left: 6px;
    color: #414141;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    font-family: 'Mulish';
    letter-spacing: -0.288px;
    word-break: break-word;
}

/* Order id + status pill (matches admin OrderDetails header) */
.order_detail_left_panel .order_no {
    font-size: 28px;
    margin-bottom: 9px;
    font-family: "proximaNova-regular" !important;
    color: #000;
}
.order_detail_left_panel .sub_text {
    font-family: "Mulish", sans-serif;
    font-size: 14px;
    color: #333;
}
.order_detail_left_panel .status_btn {
    padding: 5px 16px;
    font-size: 12px;
    line-height: 12px;
    font-weight: 600;
    color: #ED3339;
    border-radius: 100px;
}
.order_detail_left_panel .status_btn.btn_back_order {
    background-color: rgba(238, 58, 60, 0.14);
    color: #ef3032;
}
.order_detail_left_panel .btn_back_order.status-is-new {
    background: #F3F4F6;
    color: #111827;
}

.order_detail_left_panel .btn_orange {
    background-color: #E87722;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    font-family: 'Mulish', sans-serif;
    letter-spacing: 0.5px;
    padding: 9px 24px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    text-transform: uppercase;
    transition: background-color 0.2s ease;
}
.order_detail_left_panel .btn_orange:hover {
    background-color: #994705;
    color: #fff;
}

.order_detail_left_panel .phone_mail_a_tag_custom {
    margin-left: 6px;
    display: inline-flex;
    align-items: center;
    gap: 0;
    color: #414141 !important;
    text-decoration: none !important;
}

.order_detail_left_panel .phone_mail_a_tag_custom:hover {
    color: #414141 !important;
    text-decoration: none !important;
}

/* Hide phone/email icons like screenshot */
.order_detail_left_panel .phone_mail_a_tag_custom img {
    display: none;
}

.order_detail_left_panel .phone.phone-email {
    display: flex;
    align-items: center;
}

/* Hide phone/email icons and show label prefix like screenshot */
.contact-info.contact-phone img,
.contact-info.contact-email img {
    display: none;
}

.contact-info.contact-phone a,
.contact-info.contact-email a {
    display: inline-flex;
    align-items: center;
}

.contact-info.contact-phone a::before {
    content: "Phone No :";
    color: #6b7280;
    font-weight: 700;
    margin-right: 8px;
}

.contact-info.contact-email a::before {
    content: "Email :";
    color: #6b7280;
    font-weight: 700;
    margin-right: 8px;
}

/* ================================
   Finance status wizard (Figma - exact admin match)
   ================================ */
.order_detail_left_panel .steps_card .order-details-steps .wizard .field h5 {
    top: 0px !important;
    left: 10px !important;
    color: #1D6CB5 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    font-weight: 400 !important;
    font-family: 'proximal-nova', sans-serif;
}
.order_detail_left_panel .steps_card .order-details-steps .wizard .field .circle {
    border: 1px solid #1D6CB5 !important;
    background-color: transparent !important;
    border-radius: 50% !important;
    width: 25px !important;
    height: 25px !important;
    color: #1D6CB5 !important;
    font-size: 14px !important;
    line-height: 25px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex-shrink: 0;
    overflow: hidden;
}
.order_detail_left_panel .steps_card .order-details-steps .wizard .field .circle span {
    display: block;
}
.order_detail_left_panel .steps_card .order-details-steps .wizard .field .circle .checked-block {
    display: none;
}
/* done state: SVG already has blue circle + white check, just show it full size */
.order_detail_left_panel .steps_card .order-details-steps .wizard .field .circle.done {
    border: none !important;
    background-color: transparent !important;
    padding: 0 !important;
}
.order_detail_left_panel .steps_card .order-details-steps .wizard .field .circle.done span {
    display: none !important;
}
.order_detail_left_panel .steps_card .order-details-steps .wizard .field .circle.done .checked-block {
    display: block !important;
    width: 25px !important;
    height: 25px !important;
}
.order_detail_left_panel .steps_card .order-details-steps .wizard .field {
    position: relative;
}
.order_detail_left_panel .steps_card .order-details-steps .wizard .field:after {
    content: '';
    position: absolute;
    top: 13px;
    right: -70px;
    width: 24px;
    height: 1px;
    background-color: #1D6CB5 !important;
    z-index: -1;
}
.order_detail_left_panel .steps_card .order-details-steps .wizard .field.done h5 {
    font-weight: 600 !important;
    color: #1D6CB5 !important;
}
.order_detail_left_panel .steps_card .order-details-steps .wizard .field:last-child:after {
    display: none;
}
.order_details_shipping{
    margin-top: 0px !important;
}
</style>
